var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8568 1.98838C14.6143 1.86812 14.3747 1.89474 14.2127 1.9369C14.0515 1.97888 13.895 2.05468 13.7557 2.13208C13.4833 2.28334 13.1354 2.52249 12.7225 2.80626L3.66314 9.03198C3.39833 9.21393 3.15603 9.3804 2.98342 9.53069C2.82619 9.6676 2.55479 9.93084 2.54894 10.3306C2.5465 10.497 2.58397 10.6616 2.65821 10.8105C2.83655 11.1683 3.19515 11.2881 3.39616 11.3434C3.61682 11.4042 3.90729 11.4494 4.22476 11.4987L7.21781 11.9644L5.22401 15.4856C4.98678 15.9046 4.78557 16.2599 4.66271 16.5364C4.59965 16.6784 4.53923 16.8381 4.51246 17.0007C4.48534 17.1656 4.48216 17.4005 4.61767 17.627C4.71224 17.785 4.847 17.9151 5.00823 18.0041C5.23926 18.1315 5.474 18.1201 5.63776 18.0872C5.79936 18.0548 5.95686 17.9888 6.09651 17.9208C6.36857 17.7883 6.71661 17.5748 7.12695 17.323L16.2913 11.7005C16.5567 11.5377 16.8011 11.3878 16.9774 11.2494C17.1404 11.1214 17.4172 10.8771 17.447 10.4855C17.4594 10.3212 17.4328 10.1563 17.3691 10.0043C17.2174 9.64197 16.8777 9.49743 16.6827 9.42739C16.4718 9.35161 16.1926 9.28639 15.8894 9.21557L12.6617 8.4612L14.7061 4.5676C14.939 4.12403 15.1353 3.7502 15.2533 3.46187C15.3137 3.31432 15.3704 3.14997 15.393 2.98493C15.4158 2.81917 15.4138 2.57805 15.2657 2.35152C15.1642 2.19621 15.023 2.07084 14.8568 1.98838Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltWhite);
export default __webpack_public_path__ + "static/media/bolt-white.2f1e12a1dd8231740b06abe4d0f6a3d8.svg";
export { ForwardRef as ReactComponent };